export default [
  {
    name: 'Email',
    title: 'Email',
    type: 'email',
    required: true,
  },
  {
    name: 'CompanyName',
    title: 'Company Name',
    type: 'text',
    required: true
  },
  {
    name: 'FirstName',
    title: 'First Name',
    type: 'text',
    required: true
  },
  {
    name: 'LastName',
    title: 'Last Name',
    type: 'text',
    required: true
  },
  {
    name: 'Phone',
    title: 'Phone',
    type: 'number',
    required: true
  },
  {
    name: 'Title',
    title: 'Broker-Dealer',
    type: 'text',
    required: true
  },
  {
    name: "MobilePhone",
    title: "Mobile Phone",
    type: 'number',
    required: false
  },
  {
    name: "Zip",
    title: "Zip",
    type: 'number',
    required: false
  },
  {
    name: "City",
    title: "City",
    type: 'text',
    required: false
  },
  {
    name: "State",
    title: "State",
    type: 'text',
    required: false
  },
  {
    name: "Address1",
    title: "First address",
    type: 'text',
    required: false
  },
  {
    name: 'Address2',
    title: 'Second address',
    type: 'text',
    required: false
  },
  {
    name: "LinkedIn",
    title: "LinkedIn",
    type: 'text',
    required: false
  }
]